import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sokusai-management-oem-header',
  templateUrl: './sokusai-management-oem-header.component.html',
  styleUrls: ['./sokusai-management-oem-header.component.css'],
})
export class SokusaiManagementOemHeaderComponent implements OnChanges {
  imgpath: string;

  @Input()
  clientId: string;

  ngOnChanges(changes: SimpleChanges): void {
    this.imgpath = environment.apps[this.clientId].oemConfig?.imgpath;
  }
}
